import p01 from '../assets/portraits/portrait-01.svg';
import p02 from '../assets/portraits/portrait-02.svg';
import p03 from '../assets/portraits/portrait-03.svg';
import p04 from '../assets/portraits/portrait-04.svg';
import p05 from '../assets/portraits/portrait-05.svg';
import p06 from '../assets/portraits/portrait-06.svg';
import p07 from '../assets/portraits/portrait-07.svg';
import p08 from '../assets/portraits/portrait-08.svg';

/**
 * 8 retratos originales (SVG), silueta legible a 32 px (docs/art-direction.md
 * §Personajes). Sin nombre todavía: la tarea de contenido asigna personaje → retrato.
 * Paridad: 4 siluetas de complexión más ancha / pelo corto, 4 de complexión más
 * estrecha / pelo largo — una codificación deliberadamente floja, no binaria estricta.
 */
export interface PortraitDef {
  id: string;
  src: string;
  label: string;
}

export const PORTRAITS: PortraitDef[] = [
  { id: 'portrait-01', src: p01, label: 'Corte al ras, mandíbula marcada' },
  { id: 'portrait-02', src: p02, label: 'Melena larga y lisa' },
  { id: 'portrait-03', src: p03, label: 'Melena afro redondeada' },
  { id: 'portrait-04', src: p04, label: 'Moño alto' },
  { id: 'portrait-05', src: p05, label: 'Rapado, sin adornos' },
  { id: 'portrait-06', src: p06, label: 'Coleta baja' },
  { id: 'portrait-07', src: p07, label: 'Raya al lado, ondulado corto' },
  { id: 'portrait-08', src: p08, label: 'Pixie asimétrico' },
];
